export class QualityTestDefinition {
  testDefinitionId?: number;
  testName?: string;
  testCategory?: string;
  testDisplayName?: string;
  testExpectationDesc?: string;
  severity?: string;
  scoreWeight?: number;
  ruleType?: string;
  ruleField?: string;
  ruleOperator?: string;
  ruleThreshold?: string;
  aiEvalPrompt?: string;
  aiEvalModel?: string;
  appliesToIsland?: string;
  appliesToChannel?: string;
  isActive?: number;
  sortOrder?: number;
  notes?: string;
  createDate?: Date;
  lastUpdate?: Date;
}
